import * as React from 'react';

import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';
import { useRouter } from 'next/router';

import {
  getLocaleFromParams,
  setRegionLocaleList,
} from 'containers/global-dating-trends//global-dating-trends-utils';
import {
  GLOBAL_DATING_TRENDS_DEFAULT_LOCATION,
  GLOBAL_DATING_TRENDS_DEFAULT_PATH,
} from 'containers/global-dating-trends/global-dating-trends-constants';

import LanguageSelector from 'components/language-selector/language-selector';
import PageSection from 'components/page/page-section';

type GlobalDatingTrendsContentSwitchContainerProps = {
  lang?: string;
  title?: string;
  lexemes?: string[];
};

export const GlobalDatingTrendsContentSwitchContainer: React.FC<
  GlobalDatingTrendsContentSwitchContainerProps
> = (props) => {
  const isMobile = useMediaQuery(MediaQueryWidth['navigation-full']);
  const router = useRouter();
  const initLang = router.route === GLOBAL_DATING_TRENDS_DEFAULT_PATH ? '' : props.lang;
  const [defaultLang, setDefaultLang] = React.useState(initLang);
  const languagesList = React.useMemo(() => setRegionLocaleList(), []);
  const handlePathChange = (path: string, language: string) => {
    const locale = getLocaleFromParams({ lang: language });

    if (language.length === 0) {
      return (window.location.href = GLOBAL_DATING_TRENDS_DEFAULT_LOCATION);
    }

    if (!locale) {
      return;
    }

    setDefaultLang(locale);

    let windowPathName = router.pathname.startsWith('/[lang]')
      ? router.pathname.replace(/\[lang\]/, locale)
      : path;

    if (!router.pathname.startsWith('/[lang]')) {
      windowPathName = path + GLOBAL_DATING_TRENDS_DEFAULT_LOCATION;
    }

    if (!windowPathName.endsWith('/')) {
      windowPathName += '/';
    }

    return (window.location.href = windowPathName);
  };

  return (
    <PageSection
      padding={'block'}
      extraClass="page__section--max-width page__section--mobile-select-full-width"
      inner={isMobile}
    >
      <LanguageSelector
        externaLanguageList={languagesList}
        // @ts-ignore
        lang={defaultLang}
        onChange={(event) => handlePathChange(`/${event}`, event)}
      />
    </PageSection>
  );
};
